export const FLEET_PARTNER_STATUS = {
  suspend: 'suspend',
  approved: 'approved'
}
export { FLEET_PARTNER_STATUS as default }
